module.exports = __webpack_public_path__ + "static/media/10965447_880106072010816_756592512_n.0e01f824.jpg";